import React from "react";
import { useTranslation } from "react-i18next";
import {
  SCardImg,
  SEmptyBox,
  SEmptyInput,
  SGridAssets,
  SGridCard,
  SGridContainer,
  SGridDescript,
  SGridImg,
  SGridRow1,
  SGridRow2,
  SHeader,
  SHeader2,
  SMessage,
} from "./styles";
import placeHolderDonut from "../../assets/placeHolderDonut.svg";
import { usePortfolioEditor } from "../../store/hooks";

export const PortfolioPlaceHolder: React.FC = () => {
  const { t } = useTranslation();
  const { isExpanded } = usePortfolioEditor();

  return (
    <SGridContainer $isExpanded={isExpanded}>
      <SGridCard $isExpanded={isExpanded}>
        <SGridRow1 $isExpanded={isExpanded}>
          <SGridImg>
            <SCardImg src={placeHolderDonut} alt="donut" />
          </SGridImg>
          <SGridDescript $isExpanded={isExpanded}>
            <SHeader $isExpanded={isExpanded}>{t("placeHolderHeader")}</SHeader>
            <SMessage $isExpanded={isExpanded}>
              {t("placeHolderMessage")}
            </SMessage>
          </SGridDescript>
        </SGridRow1>
        {!isExpanded && (
          <SGridRow2 $isExpanded={isExpanded}>
            <SEmptyInput /> <SEmptyInput />
          </SGridRow2>
        )}
      </SGridCard>
      <SGridAssets $isExpanded={isExpanded}>
        <SHeader2>{t("placeHolderAssetsList")}</SHeader2>
        <SEmptyBox>{t("placeHolderNoAssetsSelected")}</SEmptyBox>
      </SGridAssets>
    </SGridContainer>
  );
};
